const AppReducer = (state, action) => {
  switch (action.type) {
    case "UPDATE_PARAMS":
      return {
        ...state,
        params: action.payload,
      };
    case "ADD_PARAMS":
      return {
        ...state,
        params: state.params + action.payload,
      };
    case "REMOVE_PARAMS":
        return {
          ...state,
          params: action.payload,
    };
    case "UPDATE_ENTITY_PARAMS":
      return {
        ...state,
        entity_params: action.payload,
      };
    case "ADD_ENTITY_PARAMS":
      return {
        ...state,
        entity_params: state.entity_params + action.payload,
      };
    case "REMOVE_ENTITY_PARAMS":
        return {
          ...state,
          entity_params: action.payload,
    };
    default:
      return state
  }
};

export default AppReducer
